module.exports = __webpack_public_path__ + "static/media/3_col_10.199a1a8a.jpg";